module.exports = __webpack_public_path__ + "images/mdj/members/common/common_key_sp-3a9145b1137998cdf9ba0e2703152a14.jpg";